import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { loadError, receive } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { add as addToCartService } from '../Services/Cart.service';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';

const BuyButton = ({ label, articleNumber, quantityFieldId, href, cssClass, onClick, currentArticleNumber }) => {
    const getCssClass = (cssClass, currentArticleNumber) => {
        if (!currentArticleNumber) cssClass += cssClass + '' + 'is-disabled';
        return cssClass;
    };
    return (
        <Fragment>
            {articleNumber ? (
                <button
                    className={getCssClass(cssClass, currentArticleNumber)}
                    disabled={currentArticleNumber === null}
                    onClick={(e) => {
                        e.preventDefault();
                        onClick({ articleNumber: currentArticleNumber, quantityFieldId });
                    }}
                >
                    {label}
                </button>
            ) : (
                <button className={getCssClass(cssClass, currentArticleNumber)} disabled={currentArticleNumber == null}>
                    {label}
                </button>
            )}
        </Fragment>
    );
};

const StyledButton = (props) => {
    const dispatch = useDispatch();
    const currentArticleNumber = useSelector((state) => state.product.currentArticleNumber || props.articleNumber);

    const onClick = async ({ articleNumber, quantityFieldId }) => {
        try {
            const quantity = quantityFieldId ? document.getElementById(quantityFieldId).value : 1;
            const cart = await addToCartService({ articleNumber, quantity });
            dispatch(receive(cart));

            let baseUrl = window.location.origin;
            let url = baseUrl + '/api/klaviyo/GetKlaviyoObject?articleNumber=' + articleNumber;

            fetch(url)
                .then(function (response) {
                    return response.json();
                })
                .then(function (data) {
                    klaviyo.push(["track", "Added to Cart", data]);
                })
                .catch(function (error) {
                    //Handle error
                    console.log('Error', error);
                });

            url = baseUrl + '/api/commerce/GetCommerceItemObject?articleNumber=' + articleNumber;

            fetch(url)
                .then(function (response) {
                    return response.json();
                })
                .then(function (data) {
                    console.log(data);
                    console.log(gtag);
                    gtag("event", "add_to_cart", data);
                })
                .catch(function (error) {
                    //Handle error
                    console.log('Error', error);
                });

            return true;
        } catch (ex) {
            dispatch(catchError(ex, (error) => loadError(error)));
            return false;
        }
    };
    const Button = withReactiveStyleBuyButton(BuyButton, onClick, 'buy-button');
    return <Button {...props} currentArticleNumber={currentArticleNumber} />;
};

export default StyledButton;
